import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SimpleSelect } from "@/components/app/SimpleSelect";
import { useAuth } from "@/context/AuthContext";

export const WorkspaceSwitcher = () => {
  const { user, refresh } = useAuth();
  const [list, setList] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/team/workspaces").then((r) => setList(r.data.workspaces)).catch(() => {});
  }, [user?.workspace?.owner_id]);
  if (list.length < 2) return null;
  const change = async (id) => {
    try {
      await api.post("/team/switch", { owner_id: id });
      await refresh();
      nav("/app");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="px-3 pt-3" data-testid="workspace-switcher">
      <div className="text-[11px] text-muted-foreground mb-1 px-1">Workspace</div>
      <SimpleSelect value={user?.workspace?.owner_id} onChange={change} testId="workspace-select"
        options={list.map((w) => ({ value: w.owner_id, label: w.role === "owner" ? w.name : `${w.name.replace("'s workspace", "")} (${w.role === "viewer" ? "view" : "edit"})` }))} />
    </div>
  );
};
